import React from 'react';
import PageMeta from '../../components/PageMeta';
import HeroSection from './HeroSection';
import SealedSection from './SealedSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import HowItWorksSection from './HowItWorksSection';
import CTASection from './CTASection';

export default function HomePage() {
  const canonicalUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/`
      : 'https://lilycove.io/';

  return (
    <div className="min-h-screen bg-bg-app font-landing-sans text-text-primary selection:bg-brand-primary/30">
      <PageMeta
        title="Lilycove | Skyscanner for Pokemon Cards"
        description="Search once and compare Pokemon card listings from eBay, TCGplayer, and Canadian card shops in one place."
        url={canonicalUrl}
      />
      <HeroSection />
      <SealedSection />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <CTASection />
    </div>
  );
}
